import { render, staticRenderFns } from "./InvestSection.vue?vue&type=template&id=0072642c&scoped=true&"
import script from "./InvestSection.vue?vue&type=script&lang=js&"
export * from "./InvestSection.vue?vue&type=script&lang=js&"
import style0 from "./InvestSection.vue?vue&type=style&index=0&id=0072642c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072642c",
  null
  
)

export default component.exports